import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoadingController, ModalController, NavParams, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { AuthService } from '@services/auth/auth.service';
import { EncryptService } from '@services/auth/encrypt.service';
import { AlertService } from '@services/utils/alerts/alert.service';
import { ValidationMessages } from '@services/utils/validations/validation-messages.service';
import { ValidationService } from '@services/utils/validations/validation.service';
import { first } from 'rxjs/operators';
import { ConfirmedValidator } from 'src/app/components/features/validations/confirmed.validator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss']
})
export class ChangePasswordPage implements OnInit {
  updatePasswordForm: FormGroup
  validationMessages = this.validationMessagesLoad.validationMessages

  errorsMessages: string[] = []
  submitted: boolean = false
  eyeImage: string[] = ['eye-off', 'eye-off', 'eye-off']
  typeInput: string[] = ['password', 'password', 'password']
  userData: any
  userInfo: any
  equalPasswords = false

  constructor(
    private authService: AuthService,
    private validationMessagesLoad: ValidationMessages,
    public formBuilder: FormBuilder,
    public loadingController: LoadingController,
    public modalController: ModalController,
    public navParams: NavParams,
    private storage: Storage,
    private platform: Platform,
    private validationService: ValidationService,
    private alertService: AlertService,
    private encryptService: EncryptService
  ) {}

  ngOnInit() {
    this.userData = this.navParams.data.userData
    this.validateForm()
  }

  async changePassword() {
    this.submitted = true

    await this.alertService.presentLoading()

    this.authService
      .changePassword(this.getData())
      .pipe(first())
      .subscribe(
        (res) => {
          this.success(res)
        },
        (err) => {
          this.error()
        }
      )
  }

  getData() {
    let data = this.updatePasswordForm.controls
    this.userInfo = {
      id: this.userData.id,
      password: data.password.value,
      new_password: data.new_password.value,
      email: this.userData.email
    }
    return this.userInfo
  }

  success(res) {
    this.alertService.dismiss().then(() => {
      if (res.error) {
        this.alertService.statusAlert('Error!', 'Contraseña incorrecta')
      } else {
        this.alertService.statusAlert('Contraseña restaurada!', 'La contraseña ha sido cambiada exitosamente')
        if (this.platform.is('cordova') || this.platform.is('capacitor')) this.updatePasswordBiometric()
        this.modalController.dismiss()
      }
    })
  }

  error() {
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert('Error!', 'Contraseña incorrecta')
    })
  }

  updatePasswordBiometric() {
    let data
    this.storage.get(environment.storageBiometric).then((val) => {
      if (val != null) {
        data = val
        data.password = this.encryptService.encrypt(this.userInfo.new_password)
        this.storage?.set(environment.storageBiometric, data)
      }
    })
  }

  validateForm() {
    this.updatePasswordForm = this.formBuilder.group(
      {
        password: ['', [this.validationService.Validation(6, 16, 'onlyPassword')]],
        new_password: ['', [this.validationService.Validation(6, 16, 'onlyPassword')]],
        confirm_password: ['', [this.validationService.Validation(6, 16, 'onlyPassword')]]
      },
      {
        validator: ConfirmedValidator('new_password', 'confirm_password')
      }
    )
  }

  changeImage(i: number) {
    if (this.eyeImage[i] == 'eye-off') {
      this.eyeImage[i] = 'eye'
      this.typeInput[i] = 'text'
      setTimeout(() => {
        this.eyeImage[i] = 'eye-off'
        this.typeInput[i] = 'password'
      }, 2000)
    } else {
      this.eyeImage[i] = 'eye-off'
      this.typeInput[i] = 'password'
    }
  }

  get errorControl() {
    return this.updatePasswordForm.controls
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
